namespace GeniuzPOS.ReportMasterData {
    export interface Report_1302Row {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        DocDate?: string;
        PosId?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
        FullName?: string;
    }

    export namespace Report_1302Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1302';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DocDate = "DocDate",
            PosId = "PosId",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge",
            FullName = "FullName"
        }
    }
}
